import io from "socket.io-client";

export const tenant = window.location.host.split(".")[0];

const socket = io.connect(process.env.VUE_APP_API);
socket.on("connect", () => {
  socket.emit("room", tenant);
});

export default socket;
